import React, { useContext, useState } from 'react';
import Saving from "@/components/common/Saving";

/**
 * 保存処理を実施するための関数を提供するhook
 */
export function useSaveActions () {

    const savingContext = useContext(SavingContext);

    return {
        setSaving: (value: boolean) => {
            savingContext.setSaving(value);
        },
        /**
         * 非同期保存処理です。
         * 保存処理中は画面をオーバーレイで覆います。
         */
        withSavingAsync: async (func: () => Promise<void>, options?: SavingAsyncOptions) => {
            return new Promise((resolve, reject) => {
                const opt = {
                    preventDuplication: options?.preventDuplication ?? true
                };
                if (opt.preventDuplication && savingContext.isSaving) {
                    return;
                }
                savingContext.setSaving(true);
                if (options?.message) {
                    savingContext.setMessage(options?.message);
                }
                func().then((result) => {
                    resolve(result)
                }).catch(e => {
                    reject(e);
                }).finally(() => {
                    savingContext.setSaving(false);
                });
            });
        }
    };
}


/** オプション */
interface SavingAsyncOptions {
    /**
     * 重複登録を防ぐ
     */
    preventDuplication?: boolean
    /**
     * メッセージ
     */
    message?: string
}

/**
 * 保存コンテキスト
 */
export const SavingContext = React.createContext<SavingContext>({
    isSaving: false, setSaving: () => null, setMessage: () => null,
});

/**
 * 保存コンテキスト
 */
export interface SavingContext {
    /** 保存中かどうか */
    isSaving: boolean,
    setSaving: (isSaving: boolean) => void
    /** メッセージ */
    setMessage: (message: string) => void
}

/**
 * 保存プロパティ
 * @param props プロパティ
 * @returns 
 */
export const SavingContextProvider: React.FC = (props) => {
    const [isSaving, setSaving] = useState(false);
    const [message, setMessage] = useState<string>();

    return (
        <SavingContext.Provider value={{ isSaving, setSaving, setMessage }}>
            {
                isSaving && <Saving message={message} />
            }
            {props.children}
        </SavingContext.Provider>
    );
}